import { createApp } from "vue"
import App from './App.vue'
import mitt from 'mitt' // This a Vue 3 replacement for the EventBus

const app = createApp({
	config: {
    	productionTip: false,
  	}
})

app.config.globalProperties.$emitter = mitt()
app.component('admissions-app', App)
app.mount('#general-admissions')
